import BlockRounded from '@mui/icons-material/BlockRounded';
import { Card } from '@mui/material';
import { useNavigate } from 'react-router';
import { EmptyState, PageHeader } from '../components/states';
import type { NavItem } from './nav';

/** A screen whose menu PackBytes turned off for this shop (admin panel → tenant → Menus). */
export function MenuOffPage({ item, home }: { item: NavItem; home: string | null }) {
  const navigate = useNavigate();
  return (
    <>
      <PageHeader title={item.label} />
      <Card>
        <EmptyState
          icon={<BlockRounded />}
          title={`${item.label} is turned off for your shop`}
          body="PackBytes has switched this menu off for your shop. Contact PackBytes if you need it."
          action={home ? { label: 'Go back', onClick: () => void navigate(home) } : undefined}
        />
      </Card>
    </>
  );
}
